import { Link } from "react-router-dom";
import { ShieldQuestion } from "lucide-react";
import { CARER_REVIEW_PENDING_MESSAGE } from "../../lib/carerReview";

// Shown wherever a "pending identity review" carer would otherwise hit a
// blocked action (expressing interest, a Discussion Room, their carer
// profile) — neutral message + a way to ask for review if they believe
// they were flagged in error.
export function CarerReviewNotice({ email, className = "" }) {
  const params = new URLSearchParams({ context: "carer-review" });
  if (email) params.set("email", email);

  return (
    <div
      className={`rounded-2xl border border-amber-300 bg-amber-50 p-5 flex items-start gap-3 ${className}`}
      data-testid="carer-review-pending-notice"
    >
      <ShieldQuestion className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" strokeWidth={1.75} />
      <div>
        <p className="text-sm text-amber-900">{CARER_REVIEW_PENDING_MESSAGE}</p>
        <Link
          to={`/contact?${params.toString()}`}
          className="mt-2 inline-block text-sm font-semibold text-amber-900 underline"
          data-testid="carer-review-contact-link"
        >
          Contact us
        </Link>
      </div>
    </div>
  );
}
